import { StoreCheckout } from "../../components/checkout/Checkout.types";
import { SubscriptionPlan, UserInfo } from "../../components/signup/SignUpApi";
import facebookPixel from "./facebookPixel";
import googleAds from "./googleAds";
import { mixPanelInstance } from "./mixpanel";
import tiktokPixel, { TrackedProduct } from "./tiktokPixel";

export function trackSubscribe(plan: SubscriptionPlan, userInfo?: UserInfo) {
  facebookPixel.trackSubscribe(plan, userInfo);
  tiktokPixel.trackSubscribe(plan, userInfo);
  googleAds.trackSubscribe(plan);
}

export function trackPurchase(checkout: StoreCheckout, userInfo: UserInfo | undefined) {
  if (checkout == null || userInfo == null) {
    return;
  }
  const { referral } = userInfo;
  const utmSource = referral?.split("|")[0] ?? "";
  facebookPixel.trackPurchase(checkout, userInfo);
  tiktokPixel.trackPurchase(checkout, userInfo);
  googleAds.trackPurchase(checkout);
  if (utmSource !== "") {
    mixPanelInstance.trackUTMStorePurchase(utmSource);
  }
}

export function trackLogin(userInfo?: UserInfo) {
  if (userInfo) {
    facebookPixel.trackLogin(userInfo);
  }
}

/**
 * The funnel events above the purchase.
 *
 * TikTok only, for now: the US pixel's funnel was set up around these, and the
 * Facebook wrapper has no equivalents. Adding them there later means adding a
 * call inside these functions, not chasing the call sites again.
 */
export function trackViewContent(product: TrackedProduct) {
  tiktokPixel.trackViewContent(product);
}

export function trackAddToCart(product: TrackedProduct) {
  tiktokPixel.trackAddToCart(product);
}

export function trackInitiateCheckout(checkout: StoreCheckout) {
  if (checkout == null) {
    return;
  }
  tiktokPixel.trackInitiateCheckout(checkout);
}

/** A signup reaching its end — the acquisition conversion, not a sale. */
export function trackCompleteRegistration(userInfo?: UserInfo) {
  tiktokPixel.trackCompleteRegistration(userInfo);
  googleAds.trackCompleteRegistration();
}
